<template>
  <main-content>
    <page-title icon="setting" title_text="تنظیمات"></page-title>

    <div class="row mt-3">
      <div class="col-12 col-md-4">
        <div class="bg-white shadow-sm p-4 my-2" style="border-radius: 10px">
          <div class="d-flex align-items-center">

            <div v-if="form_data.profile_image_link">
              <img :src="form_data.profile_image_link" alt="user"
                   class="rounded-circle border border-success p-1" height="64"
                   style="border-width: 3px !important; border-color: #00bea5 !important;"
                   width="64">
            </div>
            <div v-else>
              <img alt="user" class="rounded-circle border border-success p-1" height="64"
                   src="@/assets/new/image/user.jpg"
                   style="border-width: 3px !important; border-color: #00bea5 !important;"
                   width="64">
            </div>


            <div class="pr-3 h5">
              <span v-if="user.user_type == user_types.LEGAL">{{ user.com_name_fa }}</span>
              <span v-else>{{ user.first_name + ' ' + user.last_name }}</span>
            </div>
          </div>

          <div class="mt-2 pt-2">
            <div class="d-flex align-items-center my-2">
              <div class="ml-auto">ایمیل</div>
              <div class="en_num" v-text="user.email"></div>
            </div>
            <div class="d-flex align-items-center my-2">
              <div class="ml-auto">تلفن</div>
              <div v-text="user.phone"></div>
            </div>
          </div>

          <div class="mt-4 mb-2 pt-4">
            <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 1 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 1
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(1)"
            >
              <svg
                  :fill="currentTab === 1 ? '#32CDB6' : '#A0A0A1'"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h24v24H0z" fill="none"/>
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
                />
              </svg>
              <span class="pr-4">حساب کاربری</span>
            </div>
            <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 2 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 2
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(2)"
            >
              <svg
                  :fill="currentTab === 2 ? '#32CDB6' : '#A0A0A1'"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h24v24H0z" fill="none"/>
                <path
                    d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16z"></path>
              </svg>
              <span class="pr-4">اعلانات</span>
            </div>
            <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 3 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 3
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(3)"
            >
              <svg
                  :fill="currentTab === 3 ? '#32CDB6' : '#A0A0A1'"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h24v24H0z" fill="none"/>
                <path
                    d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
                />
              </svg>
              <span class="pr-4">امنیت</span>
            </div>

            <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 5 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 5
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(5)"
            >
              <svg
                  :fill="currentTab === 5 ? '#32CDB6' : '#A0A0A1'"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h24v24H0z" fill="none"/>
                <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              </svg>
              <span class="pr-4">آدرس های من</span>
            </div>
            <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 6 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 6
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(6)"
            >
              <svg
                  :fill="currentTab === 6 ? '#32CDB6' : '#A0A0A1'"
                  enable-background="new 0 0 24 24"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <rect fill="none" height="24" width="24"/>
                </g>
                <g>
                  <g>
                    <rect height="7" width="3" x="4" y="10"/>
                    <rect height="7" width="3" x="10.5" y="10"/>
                    <rect height="3" width="20" x="2" y="19"/>
                    <rect height="7" width="3" x="17" y="10"/>
                    <polygon points="12,1 2,6 2,8 22,8 22,6"/>
                  </g>
                </g>
              </svg>

              <span class="pr-4">حساب های بانکی</span>
            </div>
              <div
                  :class="[
                'py-2 px-3 my-2',
                currentTab === 10 ? 'text-success' : '',
              ]"
                  :style="
                currentTab === 10
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                  @click="changeTab(10)"
              >
                  <svg :fill="currentTab === 10 ? '#32CDB6' : '#A0A0A1'"
                       xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#a0a0a0">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path d="M240-80q-50 0-85-35t-35-85v-120h120v-560h600v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-600H320v480h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h360v80H360Zm0 120v-80h360v80H360ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm0 0h-40 400-360Z"/>
                      <!--                <circle cx="16" cy="12" r="1.5"/>-->
                  </svg>
                  <span class="pr-4">{{$t("online_contract.label.contracts")}}</span>
                  <span v-if="dataCount.pending_online_contracts > 0" class="mx-3 badge badge-pill badge-warning" style="font-size: 1em">
                      {{dataCount.pending_online_contracts}}
                  </span>
              </div>

              <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 7 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 7
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(7)"
            >
              <svg :fill="currentTab === 7 ? '#32CDB6' : '#A0A0A1'"
                   height="24px" viewBox="0 -960 960 960" width="24px" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M480-80 120-286v-399l360-195 360 195v399L480-80ZM366-578q23-23 52.5-37.5T480-630q32 0 61.5 14.5T594-578l153-90-267-142-267 142 153 90Zm84 412v-167q-52-14-86-54t-34-93q0-11 1.5-22.5T337-525l-157-93v297l270 155Zm30-224q38 0 64-26t26-64q0-38-26-64t-64-26q-38 0-64 26t-26 64q0 38 26 64t64 26Zm30 224 270-155v-297l-157 93q4 11 5.5 22.5T630-480q0 53-34 93t-86 54v167Z"/>
              </svg>

              <span class="pr-4">توکن وب سرویس</span>
            </div>


            <div
                :class="[
                'py-2 px-3 my-2',
                currentTab === 12 ? 'text-success' : '',
              ]"
                :style="
                currentTab === 12
                  ? 'border-radius: 10px; background-color: #d6f5f0;'
                  : 'cursor: pointer;'
              "
                @click="changeTab(12)"
            >
              <svg :fill="currentTab === 12 ? '#32CDB6' : '#A0A0A1'"
                   xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path d="M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm-42-176 226-226-57-57-169 169-84-84-57 57 141 141Z"/>
              </svg>
              <span class="pr-4">مجوزات و قرارداد</span>
              <span v-if="dataCount.pending_gateway_contracts > 0" class="mx-3 badge badge-pill badge-warning" style="font-size: 1em">
                {{ dataCount.pending_gateway_contracts }}
              </span>
            </div>


          </div>
        </div>
        <div class="bg-white shadow-sm p-4 my-2" style="border-radius: 10px">
          <div class="row">
            <div class="col-md-12">
              <span class="pr-4">تکمیل پروفایل</span>
              <div class="wrap-circles">
                <div :style="profile_completed_percent_color" class="circle">
                  <div class="inner">
                    <span>
                    {{ profile_completed_percent + " %" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <div class="d-block my-4">
                <div class="inside-complete-profile">
                  <div class="badge badge-success mx-4"
                       v-if="user.profile_completed.address > 0 ? true : false">
                    <svg class="bi bi-check2" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </div>
                  <div class="badge badge-danger mx-4" v-else>
                    <svg class="bi bi-x" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </div>
                  <div>
                    <i class="fas fa-map-marked-alt fa-2x"></i>
                  </div>
                  <div class="mx-profile-completed-address">
                    آدرس
                  </div>
                </div>
              </div>
              <div class="d-block my-4">
                <div class="inside-complete-profile">
                  <div class="badge badge-success mx-4"
                       v-if="user.profile_completed.is_authenticated > 0 ? true : false">
                    <svg class="bi bi-check2" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </div>
                  <div class="badge badge-danger mx-4" v-else>
                    <svg class="bi bi-x" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </div>
                  <div>
                    <i class="fa fa-user fa-2x"></i>
                  </div>
                  <div class="mx-4 px-2">
                    احزار هویت
                  </div>
                </div>
              </div>
              <div class="d-block my-4">
                <div class="inside-complete-profile">
                  <div class="badge badge-success mx-4"
                       v-if="user.profile_completed.sheba_numbers > 0 ? true : false">
                    <svg class="bi bi-check2" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </div>
                  <div class="badge badge-danger mx-4" v-else>
                    <svg class="bi bi-x" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </div>
                  <div>
                    <i class="fas fa-ethernet fa-2x"></i>
                  </div>
                  <div class="mx-profile-completed-shebanumber">
                    حساب بانکی
                  </div>
                </div>
              </div>
              <div class="d-block my-4">
                <div class="inside-complete-profile">
                  <div class="badge badge-success mx-4"
                       v-if="user.profile_completed.social_network > 0 ? true : false">
                    <svg class="bi bi-check2" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </div>
                  <div class="badge badge-danger mx-4" v-else>
                    <svg class="bi bi-x" fill="currentColor" height="16"
                         viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </div>
                  <div>
                    <i class="fab fa-instagram fa-2x"></i>
                  </div>
                  <div class="mx-profile-completed-socialmedia">
                    شبکه های اجتماعی
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-8" v-if="currentTab === 1">
        <account></account>
      </div>

      <div class="col-12 col-md-8" v-if="currentTab === 2">
        <NotificationSettings></NotificationSettings>
      </div>

      <div class="col-12 col-md-8" v-if="currentTab === 3">
        <change-password></change-password>
      </div>

      <div class="col-12 col-md-8" v-if="currentTab === 5">
        <addresses></addresses>
      </div>

      <div class="col-12 col-md-8" v-if="currentTab === 6">
        <sheba></sheba>
      </div>

      <div class="col-12 col-md-8" v-if="currentTab === 7">
        <access-token></access-token>
      </div>
      <div class="col-12 col-md-8" v-if="currentTab === 10">
        <online-contracts></online-contracts>
      </div>
      <div class="col-12 col-md-8" v-if="currentTab === 12">
        <gateway-contracts></gateway-contracts>
      </div>
    </div>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import Account from "@/pages/setting/account";
import ChangePassword from "@/pages/setting/change_password";
import Addresses from "@/pages/setting/addresses";
import Sheba from "@/pages/setting/sheba";
import AccessToken from '@/pages/setting/access-token';
import {mapGetters, mapState} from "vuex";
import PageTitle from "@/components/main/components/pageTitle";
import {userTypes} from '@/constants/userTypes'
import NotificationSettings from "./NotificationSettings.vue";
import OnlineContracts from '@/pages/setting/online-contracts.vue';
import GatewayContracts from '@/pages/setting/gateway-contracts.vue';

export default {
  name: "setting",
  components: {
      OnlineContracts,
      GatewayContracts,
    NotificationSettings,
    PageTitle,
    Sheba,
    AccessToken,
    Addresses,
    ChangePassword,
    Account,
    MainContent,
  },
  computed: {
    ...mapState("user", {
      status: (state) => state.status,
    }),
    ...mapGetters("pardakhtShakhsi", [
      "form_data"
    ]),
    ...mapGetters('user', ['dataCount']),
    profile_completed_percent_color() {
      return {'backgroundImage': `conic-gradient(#00bea5  ${this.profile_completed_percent}%, #fafafa 0)`}
    },

    profile_completed_percent() {
      return (this.user.profile_completed.is_authenticated + this.user.profile_completed.social_network + this.user.profile_completed.sheba_numbers + this.user.profile_completed.address)
    }

  },
  watch: {
    status() {
      this.user = this.$store.state.user.current_user;
    },
  },
  data() {
    return {
      user_types: userTypes,
      currentTab: 1,
      user: this.$store.state.user.current_user,
      user_profile_completed_address: false,
      user_profile_completed_sheba_numbers: false,
      user_profile_completed_social_network: false,
      user_profile_completed_is_authenticated: false,
    };
  },
  mounted() {

    if(this.$route.query.bank_account_access_tracking_code !== null){
      this.currentTab = 6;
    }

    if (this.$route.query.notif !== undefined) {
      this.currentTab = 2;
    }

    if (this.$route.params.tabslug !== undefined) {
      const slug = this.$route.params.tabslug;

      switch (slug) {
        case 'account':
          this.currentTab = 1;
          break;
        case 'email':
          this.currentTab = 2;
          break;
        case 'sms':
          this.currentTab = 3;
          break;
        case 'change-password':
          this.currentTab = 4;
          break;
        case 'addresses':
          this.currentTab = 5;
          break;
        case 'sheba':
          this.currentTab = 6;
          break;
        case 'access-token':
          this.currentTab = 7;
          break;
        case 'card-to-card-wallet':
          this.currentTab = 9;
          break;
        case 'online-contracts':
          this.currentTab = 10;
          break;
        case 'contracts':
          this.currentTab = 12;
          break;
        default:
          this.currentTab = 1;
          break;
      }
    }
  },
    methods: {
      changeTab(tab) {
          this.currentTab = tab;
          this.$store.dispatch('user/countData')
      },
    }
};
</script>

<style scoped>
.mx-profile-completed-address {
  margin: 0 2.9rem;
}

.mx-profile-completed-socialmedia {
  margin: 0 0.5rem;
}

.mx-profile-completed-shebanumber {
  margin: 0 1.6rem;
}

.wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  /* border-bottom: 1px solid #A0A0A1; */
}

.inside-complete-profile {
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle {
  position: relative;
  width: 130px;
  height: 130px;
  margin: 0.5rem;
  border-radius: 50%;
  background: #FFCDB2;
  overflow: hidden;
}

.circle .inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 115px;
  height: 115px;
  background: #fafafa;
  border-radius: 50%;
  font-size: 1.85em;
  font-weight: 300;
  color: #333;
}
</style>
